<template>
  <div class="companies">
    <SectionHeader :title="$t('meta.projects')">
      <template slot="meta">
        <Link :to="`/company/projects/new`" class="button button-green button-round button-small">{{
          $t('projects.addProject')
        }}</Link>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" />
        <LinkList>
          <LinkListItem
            v-for="project in projects"
            :primaryLink="`/company/projects/${project.uuid}`"
            :key="project.uuid"
          >
            <template #main-content>
              <span>{{ project.name }}</span>
              <span>{{ project.container_count }} {{ $t('meta.containers') }}</span>
            </template>
            <template #action-content>
              <Link :to="`/company/projects/${project.uuid}`" class="link-list-item__action"
                ><span class="material-icons">edit</span></Link
              >
              <button
                @click.prevent="removeProject(project)"
                class="link-list-item__action"
                data-testid="projects-index__delete-action"
              >
                <span class="material-icons">delete</span>
              </button>
            </template>
          </LinkListItem>
        </LinkList>
      </div>
    </div>
  </div>
</template>

<script>
import LinkListItem from '@/components/LinkList/LinkListItem.vue'
import LinkList from '@/components/LinkList/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import projectsApi from '@/api/projects'

export default {
  name: 'CompanyProjects',
  inject: ['companyUser', 'showPopup'],
  data: () => ({
    projects: null,
    loading: false,
  }),
  components: { CompanyNav, LinkList, LinkListItem, LoadingSpinner, SectionHeader },
  methods: {
    async removeProject(project) {
      const confirmAlert = await this.showPopup({
        content: this.$t('projects.deleteConfirmation'),
        confirmText: this.$t('projects.deleteConfirmText'),
        type: 'confirmDanger',
      })
      if (!confirmAlert) return

      const result = await projectsApi.delete(project.uuid)
      if (!result.success) return

      await this.fetchProjects()
    },
    async fetchProjects() {
      this.loading = true
      this.projects = await projectsApi.getAll(this.companyUser.company_uuid)
      this.loading = false
    },
  },
  async mounted() {
    await this.fetchProjects()
  },
}
</script>

<style lang="scss" scoped>
.project-wrap {
  display: flex;
  justify-content: space-between;

  > span {
    flex: 5;
  }

  &__options {
    flex: 2;
    display: flex;
    justify-content: flex-end;
    gap: 0.25rem;

    .material-icons {
      display: inline-block;
      position: unset;
    }
  }
}
</style>
